/* ============================================================
 * PERIOD CHIP — ONE box for every chip in a period row (owner 2026-10-31)
 * ------------------------------------------------------------
 * Dashboard (both headers), Leads / Daily Request (DateFilterBar) and the Deals
 * desktop period row draw every period control — preset chips, the This Month /
 * Quarter dropdown buttons, a year <select>, the 📅 Date chip — in this box:
 * same height, padding, radius, font size/weight and border. Measured before:
 * Dashboard rows mixed 28/29/37px, Deals 26/37px.
 *
 * The height is FIXED (height = minHeight = maxHeight), not padding-derived,
 * so a label, an emoji or a native <select> cannot make one chip taller than
 * its neighbours, and the phone stylesheet's `button { min-height: 40px }`
 * cannot stretch it (an inline minHeight beats that rule).
 *
 * Selected state is the same for every chip in a row: the row's own accent
 * (Dashboard / Leads / Daily Request blue, Deals amber) on border, fill and text.
 * verify-mobile-filter-chrome.js §DATE runs these and the rows that use them.
 * ============================================================ */

export var PERIOD_CHIP_H = 30;          // desktop
export var PERIOD_CHIP_H_MOBILE = 36;   // phone (< 768px)

export var PERIOD_ACCENT_BLUE = { border: "#3B82F6", bg: "#EFF6FF", fg: "#1D4ED8" };
// A row whose accent is one colour (Deals' amber): border + text in it, a 7% fill.
export function periodAccentOf(color) { return { border: color, bg: color + "12", fg: color }; }

export function periodChipStyle(active, accent, isMobile) {
  var a = accent || PERIOD_ACCENT_BLUE, h = isMobile ? PERIOD_CHIP_H_MOBILE : PERIOD_CHIP_H;
  return {
    boxSizing: "border-box", height: h, minHeight: h, maxHeight: h, margin: 0, padding: "0 12px",
    display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 4,
    border: "1px solid " + (active ? a.border : "#E2E8F0"), borderRadius: 8,
    background: active ? a.bg : "#fff", color: active ? a.fg : "#64748B",
    fontSize: 12, fontWeight: 600, lineHeight: 1, fontFamily: "inherit", whiteSpace: "nowrap", cursor: "pointer"
  };
}

// A native <select> in the same box: appearance none, the ▾ drawn INSIDE on the
// right (an inline SVG in the background shorthand), room left for it.
var CARET = "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='5' viewBox='0 0 8 5'><path d='M0 0h8L4 5z' fill='%2364748B'/></svg>\") no-repeat right 10px center";
export function periodSelectStyle(active, accent, isMobile) {
  var s = periodChipStyle(active, accent, isMobile);
  return Object.assign(s, {
    display: "inline-block", padding: "0 26px 0 12px", appearance: "none", WebkitAppearance: "none", MozAppearance: "none",
    background: s.background + " " + CARET, outline: "none", textAlign: "left"
  });
}
